import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useTexts } from '../../hooks/useTexts';
import { useLanguage } from '../../contexts/LanguageContext';
import './header.css';

export default function Header() {
  const t = useTexts();
  const { lang, toggleLang } = useLanguage();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navLinks = [
    { href: '#work', label: t.nav.work },
    { href: '#services', label: t.nav.services },
    { href: '#price', label: t.nav.price },
    { href: '#contact', label: t.nav.contact },
  ];

  return (
    <motion.header
      className={`site-header ${scrolled ? 'scrolled' : ''}`}
      initial={{ opacity: 0, y: -16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.1 }}
    >
      <a href="#top" className="header-logo">
        COPAS<span>.</span>FILMS
      </a>

      <nav className={`header-nav ${menuOpen ? 'open' : ''}`}>
        {navLinks.map(link => (
          <a
            key={link.href}
            href={link.href}
            className="nav-link"
            onClick={() => setMenuOpen(false)}
          >
            {link.label}
          </a>
        ))}
        <button className="lang-btn" onClick={toggleLang}>
          {lang === 'pt' ? 'EN' : 'PT'}
        </button>
      </nav>

      <button
        className={`menu-toggle ${menuOpen ? 'open' : ''}`}
        onClick={() => setMenuOpen(p => !p)}
        aria-label="Menu"
      >
        <span /><span /><span />
      </button>
    </motion.header>
  );
}
